import React, { createContext, useContext } from 'react';

interface InitValueProps {
  curSourceLanguage: string,
  curTargetLanguage: string,
}

export enum ActionEnum {
  updateSourceLanguage = 'curSourceLanguage',
  updateTargetLanguage = 'curTargetLanguage'
}


export interface ActionInt {
  type: ActionEnum;
  payload: unknown;
}


export const initState: InitValueProps = {
  curSourceLanguage: 'auto',
  curTargetLanguage: 'zh',
};


export const AppContext = createContext<{
  state: InitValueProps;
  dispatch: React.Dispatch<ActionInt>;
}>({
  state: initState,
  dispatch: () => ({}),
});

export function useDataContext(): {
  state: InitValueProps;
  dispatch: React.Dispatch<ActionInt>;
} {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
}

export function reducer(
  curState: InitValueProps,
  action: ActionInt,
) {
  if (action.type) {
    return {
      ...curState,
      [`${action.type}`]: action.payload,
    };
  }
  return curState;
}
